import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createElementBlock as _createElementBlock } from "vue"

import IconButton from '@/components/molecules/IconButton'
import ToolTip from '@/components/molecules/ToolTip'
import { computed, ref, withDefaults } from 'vue'

type PropsType = {
  dataTest?: string
  icon: string
  useBorder?: boolean
  useCircle?: boolean
  width: string
  bgColor?: string
  position?: string
  iconColor?: string
  onHold?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ToolTipButton',
  props: {
    dataTest: null,
    icon: null,
    useBorder: { type: Boolean },
    useCircle: { type: Boolean },
    width: null,
    bgColor: null,
    position: null,
    iconColor: null,
    onHold: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { dataTest?: string, icon: string, useBorder?: boolean, useCircle?: boolean, width: string, bgColor?: string, position?: string, iconColor?: string, onHold: boolean };



const isNavShow = ref<boolean>(false)
const timeoutId = ref<number>()

const showTooltip = computed<boolean>(() => isNavShow.value || props.onHold)

const showNav = () => {
  clearTimeout(timeoutId.value)
  isNavShow.value = true
}

const hideNav = (event: Event) => {
  if (isNavShow.value === false) {
    return false
  }
  if (event.type === 'click') {
    isNavShow.value = false
  } else {
    // 連続で実行されないようにクリアする
    clearTimeout(timeoutId.value)
    // 500msだけ非表示を遅延させる
    timeoutId.value = setTimeout(() => {
      isNavShow.value = false
    }, 500)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "tooltip_btn",
    onMouseleave: hideNav
  }, [
    _createVNode(_unref(IconButton), {
      iconColor: __props.iconColor,
      icon: __props.icon,
      bgColor: __props.bgColor,
      useBorder: __props.useBorder,
      useCircle: __props.useCircle,
      onClick: showNav,
      "data-test": __props.dataTest
    }, null, 8, ["iconColor", "icon", "bgColor", "useBorder", "useCircle", "data-test"]),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        (_unref(showTooltip))
          ? (_openBlock(), _createBlock(_unref(ToolTip), {
              key: 0,
              onHide: hideNav,
              onShow: showNav,
              width: __props.width,
              position: __props.position,
              onClick: hideNav
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "default")
              ]),
              _: 3
            }, 8, ["width", "position"]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 32))
}
}

})